module.exports = __webpack_public_path__ + "static/media/home.ba272f34.jpeg";